// extracted by mini-css-extract-plugin
export default {"id":"UsersTableRow_id__4zhSE","btnItems":"UsersTableRow_btnItems__TDeGt","btnSVG":"UsersTableRow_btnSVG__0Ab6U"};